import React, {createContext, useReducer} from 'react'

export const SET_MODULE_LIST = 'SET_MODULE_LIST'
export const SELECT_MODULE = 'SELECT_MODULE'
export const SET_SHOW_MODULE_POPUP = 'SET_SHOW_MODULE_POPUP'

const Reducer = (data, payload) => {
  switch (payload.type) {
    case SET_MODULE_LIST:
      return { ...data, module_list: payload.data }
    case SELECT_MODULE:
      return {
        ...data,
        selected_module: payload.data.selected_module,
        show_module_popup: payload.data.show_module_popup,
      }
    case SET_SHOW_MODULE_POPUP:
      return {
        ...data,
        show_module_popup: payload.data,
        selected_module: payload.data ? data.selected_module : {},
      }
    default:
      return data
  }
}

const initialState = {
  module_list: [],
  selected_module: {},
  show_module_popup: false,
}

const ModuleStore = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState)

  return (
    <ModuleContext.Provider value={[state, dispatch]}>
      {children}
    </ModuleContext.Provider>
  )
}

export const ModuleContext = createContext(initialState)
export default ModuleStore
